import { render, staticRenderFns } from "./SellPerformance.vue?vue&type=template&id=31b763b0&scoped=true"
import script from "./SellPerformance.vue?vue&type=script&lang=js"
export * from "./SellPerformance.vue?vue&type=script&lang=js"
import style0 from "./SellPerformance.vue?vue&type=style&index=0&id=31b763b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b763b0",
  null
  
)

export default component.exports